import React, { useEffect, useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import api from '../../services/api';

// iter394 — invoice / payment placeholders (single source: backend catalog).
export const BillingPlaceholderPicker = ({ onInsert }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get('/email/billing-placeholders')
      .then((r) => setItems(r.data?.placeholders || []))
      .catch(() => setItems([]));
  }, []);
  if (!items.length) return null;
  return (
    <Select value="" onValueChange={(v) => v && onInsert(v)}>
      <SelectTrigger className="h-6 w-[190px] text-xs" data-testid="billing-placeholder-picker">
        <SelectValue placeholder="+ Invoice details…" />
      </SelectTrigger>
      <SelectContent className="max-h-80">
        {items.map((p) => (
          <SelectItem key={p.key} value={p.key} className="text-xs" data-testid={`billing-placeholder-${p.key.replace(/[{}]/g, '')}`}>
            <span className="font-mono">{p.key}</span>
            <span className="block opacity-80">{p.description}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default BillingPlaceholderPicker;
